import { useContext } from 'react'
import { Layout } from '../widgets'
import { FeatureFlagContext } from '../widgets/FeatureFlagContext'
import * as routes from '../routes'
import { PaginatedList } from '../components'
import { ConversationCell } from './components'

const ConversationsView = () => {
  const { getFlagValue } = useContext(FeatureFlagContext)

  if (!getFlagValue('showDMs')) {
    return <Layout>
        <div className='welcome-title'>404</div>
        <div>There's nothing here</div>
      </Layout>
  }

  return <div className='body-container'>
      <Layout>
        <Layout.Header>Messages</Layout.Header>
          <PaginatedList
            key={'conversations'}
            loadUrl={routes.getConversationsUrl}
            cell={ConversationCell}
            cellItemPropName={'conversation'}
          />
      </Layout>
    </div>

}

export default ConversationsView
